import React from 'react';
import { commonEnums, toCapitalCase } from '@codametrix/ui-common';
import classnames from 'classnames';

const { InvoiceTypes } = commonEnums;

interface CodeProvenanceChipProps {
  codeProvenance: CMxCommonApp.CodeProvenance;
  count?: number;
}

const artifactTypeToDisplayName = (
  artifactType: CMxCommonApp.CodeSource
): string | null => {
  switch (artifactType) {
    case InvoiceTypes.CLINICAL.toString():
      return 'Provider';
    case InvoiceTypes.MAPPED.toString():
      return 'Rule';
    case InvoiceTypes.PREDICTION.toString():
      return 'Prediction';
    case InvoiceTypes.ASSEMBLED.toString():
      return 'Assembled';
    case InvoiceTypes.CODED.toString():
      return 'Coded';
    default:
      return toCapitalCase(artifactType);
  }
};

const CodeProvenanceChip = (props: CodeProvenanceChipProps) => {
  const { codeProvenance, count = 1 } = props;

  const artifactTypeDisplayName = artifactTypeToDisplayName(
    codeProvenance.artifact_type
  );

  const qaClass = `qa-code-provenance-chip-${codeProvenance.artifact_type}`;
  return (
    <div className={`code-provenance-chip ${qaClass}`}>
      {count > 1 && <span className="chip-count">{count}</span>}
      {artifactTypeDisplayName}
    </div>
  );
};

interface CodeProvenanceChipRowProps {
  codeProvenances: CMxCommonApp.CodeProvenance[];
  className?: string;
}

const CodeProvenanceChipRow = (props: CodeProvenanceChipRowProps) => {
  const { codeProvenances, className } = props;

  // Group provenances by artifact type using array
  const groupedProvenances = (codeProvenances || [])
    .filter(provenance => provenance)
    .reduce((acc, provenance) => {
      const existingGroup = acc.find(
        group => group.provenance.artifact_type === provenance.artifact_type
      );
      if (existingGroup) {
        existingGroup.count++;
      } else {
        acc.push({
          provenance,
          count: 1
        });
      }
      return acc;
    }, [] as Array<{ provenance: CMxCommonApp.CodeProvenance; count: number }>);

  return (
    <div className={classnames('code-provenance-chip-row', className)}>
      {groupedProvenances.map(({ provenance, count }) => (
        <CodeProvenanceChip
          key={`${provenance.artifact_type}-${count}`}
          codeProvenance={provenance}
          count={count}
        />
      ))}
    </div>
  );
};

export default CodeProvenanceChipRow;
